import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  mappingNameTitle: {
    id: 'ufMvyG',
    defaultMessage: 'Template Name <optionalMessage>(optional)</optionalMessage>',
    description: 'Mapping name input title',
  },
  mappingNameRepeatedMessage: {
    description: 'Import template name is repeated message',
    defaultMessage: 'Template name has to be unique',
    id: 'DWOTiD',
  },
  matchColumns: {
    id: 'Traz6u',
    defaultMessage: 'Match Fields',
    description: 'Title above mapping delivering information',
  },
  matchingInfo1: {
    id: 'IIeT8t',
    defaultMessage:
      'Match your CSV column headers to the corresponding field in ShipStation. Enter a name to save as a template for future use.',
    description: 'Information about mapping',
  },
});
